import React, { useState } from 'react';
import AddNewAssetsForm from '../components/AddNewAssetsForm';
import MonetiseSettingsForm from '../components/MonetiseSettingsForm';
import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { NewAssetsFormValues, NewAssetsSchema } from '../validation';

const NewAssetsPage = () => {
  const [step, setStep] = useState(1);

  const form = useForm<NewAssetsFormValues>({
    resolver: zodResolver(NewAssetsSchema),
    defaultValues: {
      name: '',
      metadata: [],
      thumbnail: null,
      content: '',
      description: '',
      document: null,
    },
  });

  const renderStep = (step: number) => {
    if (step === 1)
      return (
        <AddNewAssetsForm onSubmit={() => setStep(step + 1)} form={form} />
      );

    return <MonetiseSettingsForm values={form.getValues()} />;
  };

  return (
    <div className='from-gray-950 via-gray-900 to-gray-950 flex min-h-screen bg-gradient-to-br'>
      {renderStep(step)}
    </div>
  );
};

export default NewAssetsPage;
